var _g, _rect, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaxonomyEmptyState = function SvgTaxonomyEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 457,
    height: 279,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 263,
    x: 8,
    y: 7,
    fill: "#fff",
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 267,
    x: 6,
    y: 5,
    stroke: "#fff",
    strokeWidth: 4,
    rx: 22
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 263,
    x: 8,
    y: 7,
    fill: "#7CCDA1",
    fillOpacity: 0.15,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "8 8",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M174 105.722c7.741.166 26.889 0 40.944 4.5 17.121 5.481 22.612 14 58.056 15.5M174 68c7.741.167 26.889 0 40.944 4.5 17.121 5.481 22.612 14 58.056 15.5M174 140.722c7.741.166 26.889 0 40.944 4.5 17.121 5.481 22.612 14 58.056 15.5M174 173.722c7.741.166 26.889 0 40.944 4.5 17.121 5.481 22.612 14 58.056 15.5M174 208.722c7.741.166 26.889 0 40.944 4.5 17.121 5.481 22.612 14 58.056 15.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 29,
    x: 271,
    y: 40,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374F59",
    d: "M271 46a6 6 0 0 1 6-6h15v29h-15a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 300,
    y: 52,
    fill: "#D9D9D9",
    rx: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M271 81a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H277a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374F59",
    d: "M271 81a6 6 0 0 1 6-6h15v29h-15a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 300,
    y: 87,
    fill: "#D9D9D9",
    rx: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M271 116a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H277a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374F59",
    d: "M271 116a6 6 0 0 1 6-6h15v29h-15a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 300,
    y: 122,
    fill: "#D9D9D9",
    rx: 3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M271 151a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H277a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374F59",
    d: "M271 151a6 6 0 0 1 6-6h15v29h-15a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 300,
    y: 157,
    fill: "#D9D9D9",
    rx: 3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M271 186a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H277a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374F59",
    d: "M271 186a6 6 0 0 1 6-6h15v29h-15a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 300,
    y: 192,
    fill: "#D9D9D9",
    rx: 3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M271 221a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H277a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374F59",
    d: "M271 221a6 6 0 0 1 6-6h15v29h-15a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 300,
    y: 227,
    fill: "#D9D9D9",
    rx: 3
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 29,
    x: 59,
    y: 53.722,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B03E",
    d: "M59 59.722a6 6 0 0 1 6-6h15v29H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 88,
    y: 65.722,
    fill: "#D9D9D9",
    rx: 3
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__i)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 29,
    x: 59,
    y: 88.722,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B03E",
    d: "M59 94.722a6 6 0 0 1 6-6h15v29H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 88,
    y: 100.722,
    fill: "#D9D9D9",
    rx: 3
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 129.722a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B03E",
    d: "M59 129.722a6 6 0 0 1 6-6h15v29H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 88,
    y: 135.722,
    fill: "#D9D9D9",
    rx: 3
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 164.722a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B03E",
    d: "M59 164.722a6 6 0 0 1 6-6h15v29H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 88,
    y: 170.722,
    fill: "#D9D9D9",
    rx: 3
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#taxonomy-empty-state_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 199.722a6 6 0 0 1 6-6h115a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B03E",
    d: "M59 199.722a6 6 0 0 1 6-6h15v29H65a6 6 0 0 1-6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 88,
    y: 205.722,
    fill: "#D9D9D9",
    rx: 3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 78,
    r: 11,
    fill: "#7DD0A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m225 77.23 3.6 3.77 5.4-7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 149,
    r: 11,
    fill: "#7DD0A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m225 148.231 3.6 3.769 5.4-7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 182,
    r: 11,
    fill: "#7DD0A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m225 181.231 3.6 3.769 5.4-7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 218,
    r: 11,
    fill: "#7DD0A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m225 217.231 3.6 3.769 5.4-7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__a",
    width: 457,
    height: 279,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__b",
    width: 135,
    height: 37,
    x: 267,
    y: 37,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__c",
    width: 135,
    height: 37,
    x: 267,
    y: 72,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__d",
    width: 135,
    height: 37,
    x: 267,
    y: 107,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__e",
    width: 135,
    height: 37,
    x: 267,
    y: 142,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__f",
    width: 135,
    height: 37,
    x: 267,
    y: 177,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__g",
    width: 135,
    height: 37,
    x: 267,
    y: 212,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__h",
    width: 135,
    height: 37,
    x: 55,
    y: 50.722,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__i",
    width: 135,
    height: 37,
    x: 55,
    y: 85.722,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__j",
    width: 135,
    height: 37,
    x: 55,
    y: 120.722,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__k",
    width: 135,
    height: 37,
    x: 55,
    y: 155.722,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "taxonomy-empty-state_svg__l",
    width: 135,
    height: 37,
    x: 55,
    y: 190.722,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_2507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_171_2507",
    result: "shape"
  })))));
};
export default SvgTaxonomyEmptyState;